import { render } from "./DettaglioRapportino.vue?vue&type=template&id=54dd4af2&scoped=true"
import script from "./DettaglioRapportino.vue?vue&type=script&lang=js"
export * from "./DettaglioRapportino.vue?vue&type=script&lang=js"

import "./DettaglioRapportino.vue?vue&type=style&index=0&id=54dd4af2&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dd4af2"]])

export default __exports__